// Who sees the "blocked" screen instead of the dashboard, and what it says.
//
// Drivers are blocked from this board (6932308) -- they work from the HMGC Driver
// app. But a driver also lands here the first time: the invite link opens the
// board, the driver sets a password, and the next screen used to read "Access
// blocked -- please contact your administrator", which reads like the password
// did not work. For a driver the screen now says what just happened and where to
// go next, with the download link (Henry, 2026-09-26).
//
// Every other role that ends up on this screen keeps the plain blocked text.
// Pure so sim/blockedscreen.test.mjs can run it without a browser.

// The page on hub that serves the driver APK. The key is AVAILABLE_SOFTWARE's
// 'driver-app' in Billing-Manager (the route is /software/<key>, with a hyphen:
// /software/driver_app answers "Unknown app."). It asks the driver to sign in on
// hub first -- same email and password as the one just set here.
export const DRIVER_APP_URL = 'https://hub.hmgc.io/software/driver-app';

export const DRIVER_MESSAGE = 'Password set — open the HMGC Driver app to sign in.';
export const BLOCKED_MESSAGE = 'Access blocked — please contact your administrator.';

// __SHOP_ROLE__ (2026-09-27) The Shop / Fleet role (profiles role 'shop') uses HM Shop Desktop and the
// HM Shop phone app only -- not this board. Its people land here too (a sign-in on this board, or the
// invite's set-password landing when Supabase sends it here), so the screen says where to go.
export const SHOP_DESKTOP_URL = 'https://hm-shop-desktop.vercel.app';
export const SHOP_MESSAGE = 'Your account is for HM Shop only.';

export function blockedScreenContent(role) {
  if (role === 'driver') {
    return {
      icon: '✅',
      title: DRIVER_MESSAGE,
      link: { href: DRIVER_APP_URL, label: 'Get the HMGC Driver app' },
      note: 'No app yet? Open the link on your phone and sign in with the same email and password.',
    };
  }
  if (role === 'shop') {
    return {
      icon: '🔧',
      title: SHOP_MESSAGE,
      link: { href: SHOP_DESKTOP_URL, label: 'Open HM Shop Desktop' },
      note: 'Sign in there with the same email and password. For the phone app, open hub.hmgc.io/software/shop on your Android phone.',
    };
  }
  return { icon: '🔒', title: BLOCKED_MESSAGE, link: null, note: null };
}
